type ImageRatio = {
  width: number;
  height: number;
  fontSize: number;
} & BreakPoint;

type BreakPoint = {
  minWidth: number;
  maxWidth?: number;
  rate: number;
};

export type BreakPoints = {
  mobile: BreakPoint;
  tablet: BreakPoint;
  desktop: BreakPoint;
};

export type ImageRatios = {
  featured: Record<keyof BreakPoints, ImageRatio>;
  gameCard: Record<keyof BreakPoints, ImageRatio>;
};

export enum Devices {
  "Mobile",
  "Tablet",
  "Desktop",
}

export interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice?: Promise<{ outcome: "accepted" | "dismissed" }>;
}
